// extracted by mini-css-extract-plugin
export default {"button":"Zj-z","reviewSort":"_j-z"};